var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[(_vm.staticTitle)?_c('h2',[_vm._v(_vm._s(_vm.staticTitle))]):_vm._e(),_c('p'),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }